import { useProject } from 'hooks/projects'
import { useCredits } from 'hooks/usage'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useAuth } from 'util/auth'

export const UpgradeBanner = () => {
  const router = useRouter()
  const auth = useAuth()
  const { data: credits } = useCredits({
    projectId: router.query.project_id,
    userId: auth?.user?.id,
  })
  const { data: project } = useProject({ projectId: router.query.project_id })

  const isOwner = project?.owner === auth?.user?.id

  if (!credits) return null
  if (!isOwner) return null
  if (isOwner && credits?.userCredits > 0.2) return null

  return (
    <Link href="/settings?tab=manage-plan">
      <div className="flex items-center gap-x-6 bg-white px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
        <div className="flex items-center text-sm leading-6 text-gray-500">
          <strong className="font-semibold">
            {credits?.userCredits === 0
              ? "You're out of upload minutes"
              : `You're almost out of upload minutes`}
          </strong>
          <svg
            viewBox="0 0 2 2"
            className="mx-2 inline h-0.5 w-0.5 fill-current"
            aria-hidden="true"
          >
            <circle cx={1} cy={1} r={1} />
          </svg>
          <div className="flex items-center">
            <p className="underline underline-offset-4">Add minutes</p>
            <span aria-hidden="true" className="ml-2">
              &rarr;
            </span>
          </div>
        </div>
        <div className="flex justify-end"></div>
      </div>
    </Link>
  )
}
